import {NgModule} from '@angular/core';
import {AppComponent} from '../app.component';
import {NavComponent} from './components/templates/header-template/nav/nav.component';
import {LoaderComponent} from './shared/loader/loader.component';
import {OAuthCallbackComponent} from './services/oauth/oauth-callback.component';
import {LogoutComponent} from './components/routes/logout/logout.component';
import {NoAccessComponent} from './components/routes/no-access/no-access.component';
import {OutboundComponent} from './components/routes/outbound/outbound.component';
import {PackingComponent} from './components/routes/outbound/packing/packing.component';
import {InboundComponent} from './components/routes/inbound/inbound.component';
import {ReceivingComponent} from './components/routes/inbound/receiving/receiving.component';
import {PartsMovementComponent} from './components/routes/inbound/parts-movement/parts-movement.component';
import {UserConfigComponent} from './components/templates/header-template/user-config/user-config.component';
import {UserLocationComponent} from './components/templates/header-template/user-config/user-warehouse/user-location.component';
import {HeaderTemplateComponent} from './components/templates/header-template/header-template.component';
import {CdsidComponent} from './components/templates/header-template/user-config/user-cdsid/cdsid.component';
import {AlertCustomComponent} from './shared/alert-custom/alert-custom.component';
import {InputGenericComponent} from './shared/input-generic/input-generic.component';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {RouterModule} from '@angular/router';
import {DialogModule} from 'primeng/dialog';
import {ButtonModule} from 'primeng/button';
import {MenubarModule} from 'primeng/menubar';
import {PanelMenuModule} from 'primeng/panelmenu';
import {ToastModule} from 'primeng/toast';
import {DrawerModule} from 'primeng/drawer';
import {HTTP_INTERCEPTORS, HttpClient, HttpClientModule} from '@angular/common/http';
import {CarouselModule} from 'primeng/carousel';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MessageModule} from 'primeng/message';
import {PanelModule} from 'primeng/panel';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {UrlConsumerService} from './services/oauth/url-consumer.service';
import {AuthGuardService} from './services/oauth/auth-guard.service';
import {LoginService} from './services/oauth/login.service';
import {PkceService} from './services/oauth/pkce.service';
import { MessageService, ConfirmationService } from 'primeng/api';
import {Globals} from './shared/globals/globals';
import {MessageBeep} from './services/messageBeep/messageBeep.service';
import {UtilsService} from './shared/utils.service';
import {WarehouseService} from './services/warehouse/warehouse.service';
import {HasPrinterService} from './services/oauth/has-printer.service';
import {LoaderInterceptorService} from './shared/loader/service/loader-interceptor.service';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {routing} from './wings-mobile-routing.module';
import {WingsMobileComponent} from './wings-mobile.component';
import {InstallPromptComponent} from './components/templates/install-prompt/install-prompt.component';
import {FooterTemplateComponent} from './components/templates/footer-template/footer-template.component';
import {HomePageComponent} from './components/routes/home-page/home-page.component';
import {InputTextModule} from 'primeng/inputtext';
import { StockPickComponent } from './components/routes/inbound/stock-pick/stock-pick.component';
import { RadioButtonModule } from 'primeng/radiobutton'
import { InputPComponent } from './shared/input/input.component';
import { InConstructionComponent } from './components/routes/in-construction/in-construction.component';
import { ConstructionTemplateComponent } from './components/templates/construction-template/construction-template.component';
import {ConferenceComponent} from './components/routes/inbound/conference/conference.component';
import { SelectModule } from 'primeng/select';
import { CycleCountComponent } from './components/routes/cycle-count/cycle-count.component';
import { SettingsComponent } from './components/routes/settings/settings.component';
import { AuditComponent } from './components/routes/audit/audit.component';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ManageWarehouseComponent } from './components/routes/manage-warehouse/manage-warehouse.component';
import { DenialComponent } from './components/routes/manage-warehouse/denial/denial.component';
import {TimelineModule} from 'primeng/timeline';
import { DispatchingInvoicingComponent } from './components/routes/outbound/dispatching-invoicing/dispatching-invoicing.component';
import { PickingComponent } from './components/routes/outbound/picking/picking.component';
import {CheckboxModule} from "primeng/checkbox";
import { CaseInfoDisplayComponent } from './components/routes/outbound/dispatching-invoicing/case-info-display/case-info-display.component';
import { CaseInfoEditionComponent } from './components/routes/outbound/dispatching-invoicing/case-info-display/case-info-edition/case-info-edition.component';
import { LoadInfoDisplayComponent } from './components/routes/outbound/dispatching-invoicing/load-info-display/load-info-display.component';
import { HandheldFormDirective } from './directives/handheld-form.directive';
import { ResourceDirective } from './directives/resource.directive';
import { RedisSessionInterceptor } from './services/resource/user-resources.service';
import { ExportChooseModalComponent } from "./components/routes/outbound/dispatching-invoicing/export-choose-modal/export-choose-modal.component";

@NgModule({
    imports: [
        routing,
        BrowserModule,
        BrowserAnimationsModule,
        RouterModule,
        DialogModule,
        ButtonModule,
        MenubarModule,
        PanelMenuModule,
        ToastModule,
        InputTextModule,
        DrawerModule,
        HttpClientModule,
        CarouselModule,
        FormsModule,
        ReactiveFormsModule,
        MessageModule,
        PanelModule,
        ToastModule,
        RadioButtonModule,
        SelectModule,
        ConfirmDialogModule,
        TimelineModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
        CheckboxModule,
        WingsMobileComponent,
        NavComponent,
        LoaderComponent,
        OAuthCallbackComponent,
        LogoutComponent,
        NoAccessComponent,
        HomePageComponent,
        OutboundComponent,
        PackingComponent,
        InboundComponent,
        ReceivingComponent,
        PartsMovementComponent,
        ConferenceComponent,
        UserConfigComponent,
        UserLocationComponent,
        HeaderTemplateComponent,
        CdsidComponent,
        AlertCustomComponent,
        InputGenericComponent,
        InstallPromptComponent,
        FooterTemplateComponent,
        StockPickComponent,
        InputPComponent,
        InConstructionComponent,
        ConstructionTemplateComponent,
        CycleCountComponent,
        SettingsComponent,
        AuditComponent,
        ManageWarehouseComponent,
        DenialComponent,
        DispatchingInvoicingComponent,
        PickingComponent,
        CaseInfoDisplayComponent,
        CaseInfoEditionComponent,
        LoadInfoDisplayComponent,
        HandheldFormDirective,
        ResourceDirective,
        ExportChooseModalComponent
    ],
    providers: [
        UrlConsumerService,
        AuthGuardService,
        LoginService,
        MessageService,
        Globals,
        MessageBeep,
        UtilsService,
        WarehouseService,
        HasPrinterService,
        NavComponent,
        ConfirmationService,
        PkceService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: LoaderInterceptorService,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: RedisSessionInterceptor,
            multi: true
        }
    ],
    bootstrap: [AppComponent]
})
export class WingsMobileModule{

}

export function HttpLoaderFactory(http: HttpClient) {
	return new TranslateHttpLoader(http);
}
